export const formatNumberWithCommas = number => {
  const parts = number.toString().split(".");
  parts[0] = new Intl.NumberFormat("en-US").format(parts[0]);
  return parts.join(".");
};

export const unFormatNumberWithCommas = formattedNumber => {
  return parseFloat(formattedNumber.replace(/,/g, ""));
};
